import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ setIsAuthenticated }) {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const res = await api.post('/auth/google-callback', { session_id: sessionId });
        const { access_token, user, tenant_modules } = res.data;

        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));
        if (tenant_modules) localStorage.setItem('tenant_modules', JSON.stringify(tenant_modules));

        if (setIsAuthenticated) setIsAuthenticated(true);

        // Clear hash and redirect to dashboard
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      } catch {
        navigate('/login');
      }
    })();
  }, [navigate, setIsAuthenticated]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#FDFBF7]">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-muted-foreground">Signing you in with Google...</p>
      </div>
    </div>
  );
}
